import styled from "@emotion/styled";

import { fontAngkor, theme } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { StyledQuizFlag } from "scmp-app/components/content/content-item-render/variants/posties-primary/styles";
import { Headline } from "scmp-app/components/posties/content-homepage/headline";
import { YourSayAuthor } from "scmp-app/components/posties/content-homepage/your-say/your-say-author";
import { OffsetContainer } from "scmp-app/components/posties/offset-container";

import ArrowBorder from "./arrow-border.svg?url";
import Arrow from "./arrow.svg?url";
import GrassMobile from "./grass-mobile.png";
import Grass from "./grass.png";

export const StyledContentCoverImage = styled(ContentCoverImage)`
  border-radius: 16px;

  overflow: hidden;
`;

export const Container = styled.div`
  position: relative;
  z-index: 1;

  background: #ffffff;

  overflow: hidden;
`;

export const StyledHeadline = styled(Headline)`
  margin-block: 40px 24px;

  ${theme.breakpoints.up("tablet")} {
    margin-block: 73px 56px;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-block-start: 56px;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-block-start: 8px;
  }
`;

export const MessageContainer = styled.div`
  position: relative;

  margin-block-end: 49px;
  margin-inline: auto;
  padding-block: 0;
  padding-inline: 29px 17px;

  &::before,
  &::after {
    position: absolute;
    content: "";

    transform: translateX(-50%);
  }

  &::before {
    inset-block-end: -34px;
    inset-inline-start: calc(50% - 8px);

    inline-size: 29px;
    block-size: 34px;

    background: url(${Arrow});
  }

  &::after {
    inset-block-end: -21px;
    inset-inline-start: 50%;

    inline-size: 29px;
    block-size: 34px;

    background: url(${ArrowBorder});
  }

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 678px;
    margin-block-end: 57px;
    padding-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 800px;
  }
`;

export const StyledOffsetContainer = styled(OffsetContainer)`
  display: block;

  padding-block: 30px 21px;
  padding-inline: 19px 31px;

  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 46px 28px;
    padding-inline: 47px 36px;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block: 52px 49px;
    padding-inline: 44px 53px;
  }
`;

export const StyledArticleHeadline = styled.div`
  margin-block: 24px;

  color: #333333;
  font-size: 24px;
  font-family: ${fontAngkor};
  line-height: 28px;
  letter-spacing: -0.72px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 24px;

    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.96px;
  }
`;

export const YourSayAuthors = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  justify-content: center;

  margin-block-end: 53.4%;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 23%;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 16%;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    margin-block-end: 9%;
  }
`;

export const StyledYourSayAuthor = styled(YourSayAuthor)`
  &:not(:last-child) {
    margin-inline-end: 16px;

    ${theme.breakpoints.up("tablet")} {
      margin-inline-end: 20px;
    }
  }
`;

export const StyledGrass = styled.div`
  position: absolute;
  inset-block-end: -3%;
  inset-inline-start: 0;

  inline-size: 100%;
  padding-block-start: 54%;

  background-image: url(${GrassMobile.src});
  background-repeat: no-repeat;
  background-size: contain;

  ${theme.breakpoints.up("tablet")} {
    padding-block-start: 35%;

    background-image: url(${Grass.src});
    background-position: top;
    background-size: cover;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 26.4%;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    inset-block-end: 0;

    padding-block-start: 19.8%;
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  ${StyledQuizFlag} {
    inset-inline-start: -13px;

    ${theme.breakpoints.up("tablet")} {
      inset-inline-start: -20px;
    }

    ${theme.breakpoints.up("desktop")} {
      inset-inline-start: -20px;
    }
  }
`;
